import { Product, Solution } from "common/learnerPreferences";

/**
 * Map solutions to products.
 */
export const solutionToProducts: Record<Solution, Product[]> = {
  [Solution.Ai]: [Product.Einstein],
  [Solution.Automation]: [Product.DataCloud, Product.Einstein],
  [Solution.CustomerSuccess]: [Product.ServiceCloud],
  [Solution.Data]: [Product.DataCloud, Product.Einstein, Product.Tableau],
  [Solution.Relationships]: [Product.MarketingCloud],
  [Solution.Sales]: [Product.SalesCloud],
};

/**
 * Some products are grouped under a single umbrella product.
 */
export const productGroups: Partial<Record<Product, Product[]>> = {
  [Product.Einstein]: [
    Product.Einstein,
    Product.EinsteinCopilot,
    Product.PromptBuilder,
    Product.CodeBuilder,
  ],
  [Product.SalesCloud]: [Product.RevenueCloud, Product.SalesCloud],
  [Product.MarketingCloud]: [
    Product.AccountEngagement,
    Product.JourneyBuilder,
    Product.MarketingCloud,
  ],
  [Product.ServiceCloud]: [Product.ServiceCloud, Product.FieldService],
  [Product.SalesforcePlatform]: [
    Product.SalesforcePlatform,
    Product.SalesforceMobileApp,
    Product.FlowBuilder,
  ],
};
